import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { X } from "lucide-react"
import { cn } from "@/lib/utils"

const Dialog = DialogPrimitive.Root
const DialogTrigger = DialogPrimitive.Trigger
const DialogPortal = DialogPrimitive.Portal
const DialogClose = DialogPrimitive.Close

const DialogOverlay = React.forwardRef(({ className, style, ...props }, ref) => (
  <DialogPrimitive.Overlay ref={ref} className={cn("tw:fixed tw:inset-0 tw:z-50 tw:bg-black/50 tw:backdrop-blur-sm", className)} style={{ animation: 'none', ...style }} {...props} />
))
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName

const DialogContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <DialogPortal>
    <DialogOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={cn("tw:fixed tw:left-[50%] tw:top-[50%] tw:z-50 tw:grid tw:w-full tw:max-w-lg tw:translate-x-[-50%] tw:translate-y-[-50%] tw:gap-4 tw:border tw:border-gray-200 tw:bg-white tw:p-6 tw:shadow-modal tw:sm:rounded-card", className)}
      style={{ animation: 'none' }}
      {...props}
    >
      {children}
      <DialogPrimitive.Close className="tw:absolute tw:right-4 tw:top-4 tw:rounded-sm tw:opacity-70 tw:ring-offset-white tw:transition-opacity tw:hover:opacity-100 tw:focus:outline-none tw:focus:ring-2 tw:focus:ring-brand-secondary tw:focus:ring-offset-2 tw:disabled:pointer-events-none">
        <X className="tw:h-4 tw:w-4" />
        <span className="tw:sr-only">Close</span>
      </DialogPrimitive.Close>
    </DialogPrimitive.Content>
  </DialogPortal>
))
DialogContent.displayName = DialogPrimitive.Content.displayName

const DialogHeader = ({ className, ...props }) => (<div className={cn("tw:flex tw:flex-col tw:space-y-1.5 tw:text-center tw:sm:text-left", className)} {...props} />)
DialogHeader.displayName = "DialogHeader"

const DialogFooter = ({ className, ...props }) => (<div className={cn("tw:flex tw:flex-col-reverse tw:gap-3 tw:sm:flex-row tw:sm:justify-end", className)} {...props} />)
DialogFooter.displayName = "DialogFooter"

const DialogTitle = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Title ref={ref} className={cn("tw:!text-lg tw:!font-semibold tw:!normal-case tw:leading-none tw:tracking-tight tw:text-gray-900", className)} {...props} />
))
DialogTitle.displayName = DialogPrimitive.Title.displayName

const DialogDescription = React.forwardRef(({ className, ...props }, ref) => (
  <DialogPrimitive.Description ref={ref} className={cn("tw:text-sm tw:text-gray-500", className)} {...props} />
))
DialogDescription.displayName = DialogPrimitive.Description.displayName

export { Dialog, DialogPortal, DialogOverlay, DialogTrigger, DialogClose, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogDescription }
